export const CLASS_ROOT = "promotion-card";
export const CLASS_SECTION = `${CLASS_ROOT}__section`;
export const CLASS_CONTENT = `${CLASS_ROOT}__content`;
export const CLASS_IMAGE_WRAPPER = `${CLASS_ROOT}__image-wrapper`;
export const CLASS_TITLE = `${CLASS_ROOT}__title`;
